<template>
  <vue-dropzone
    id="drop1"
    :options="dropOptions"
    @vdropzone-success="successUpload"
  />
</template>
<script>
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueDropzone from "vue2-dropzone";
import { getToken } from "../lib/httplib";
export default {
  components: {
    VueDropzone,
  },
  data() {
    return {
      dropOptions: {
        url: process.env.VUE_APP_API_HOST + "/api/admin/file/image",
        paramName: "image",
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      },
    };
  },
  methods: {
    successUpload(resp, data) {
      this.$emit("success", data.data);
    },
  },
};
</script>